export enum Objects {
	PAGE = 'page',
	STUDY = 'study',
	ORGANISATION = 'organisation',
	USER = 'user'
}
